export default "__VITE_ASSET__COaBkOtM__"